import { Segmented } from 'antd'
import { Dispatch, SetStateAction, useMemo, useRef, useState } from 'react'
import styles from './index.module.less'
import { useGlobalStore } from '@/hoxStore/globalStore'

export interface IbtnListItem {
  name: string
  active: boolean
  value: any
}

const Index = ({
  btnList = [],
  setBtnList,
  renderKey = new Date().getTime().toString(),
}: {
  btnList: IbtnListItem[]
  setBtnList: Dispatch<SetStateAction<IbtnListItem[]>>
  renderKey?: string
}) => {
  const lastIndex = useRef(0)
  const [options] = useState<string[]>(() => {
    return btnList.map((item) => {
      return item.name
    })
  })
  const defaultValue = useMemo(() => {
    const i = btnList.find((item) => {
      return item.active
    })
    return i?.name
  }, [btnList])
  const commonTabEl = useRef<HTMLDivElement | null>(null)
  const { curReponsive } = useGlobalStore()
  return (
    <div className={styles.wrap} ref={commonTabEl} key={renderKey}>
      <Segmented
        defaultValue={defaultValue}
        options={options}
        shape="round"
        onChange={(val) => {
          const index = btnList.findIndex((item) => {
            return item.name === val
          })
          const newArr = btnList.map((i, iIndex) => {
            i.active = false
            return {
              ...i,
              active: iIndex === index,
            }
          })
          setBtnList(newArr)
          if (curReponsive?.size === 'mobile') {
            if (index === 0) {
              commonTabEl.current?.scrollTo({
                left: 0,
                behavior: 'smooth',
              })
            } else if (index > 0 && index < btnList.length - 1) {
              setTimeout(() => {
                const width =
                  (commonTabEl.current as any)!
                    .querySelector('.ant-segmented-item')
                    ?.getBoundingClientRect().width - 100 || 0

                commonTabEl.current?.scroll(width, 0)
              }, 0)
            }
            if (index === btnList.length - 1) {
              setTimeout(() => {
                commonTabEl.current?.scroll(99999, 0)
              }, 0)
            }
          }
          lastIndex.current = index
        }}
      />
    </div>
  )
}

export default Index
